import { ChangeEvent } from 'react';

export function getImageData(event: ChangeEvent<HTMLInputElement>) {
  // FileList is immutable, so we need to create a new one
  const dataTransfer = new DataTransfer();

  // Add newly uploaded images
  Array.from(event.target.files!).forEach((image) =>
    dataTransfer.items.add(image),
  );

  const files = dataTransfer.files;
  const previewFile = event.target.files![0]!;
  const previewUrl = URL.createObjectURL(previewFile);

  return { files, previewUrl };
}

export const clearObjectUrl = (url?: string) => {
  if (!url || !url.startsWith('blob:')) {
    return;
  }

  URL.revokeObjectURL(url);
};

export const downloadByUrl = async ({
  url,
  filename,
}: {
  url: string;
  filename: string;
}) => {
  const blob = await fetch(url)
    .then((r) => r.blob())
    .catch(() => {
      return null;
    });
  if (!blob) {
    return false;
  }

  const extSplit = url.split('.');
  const ext = extSplit[extSplit.length - 1];

  downloadBlob({
    filename: ext ? `${filename}.${ext}` : filename,
    blob,
  });

  return true;
};

export const downloadBlob = ({
  filename,
  blob,
}: {
  filename: string;
  blob: Blob;
}) => {
  const internUrl = URL.createObjectURL(blob);

  // Create fake link to download file
  const a = document.createElement('a');
  a.href = internUrl;
  a.download = filename;

  // Simulate file click
  a.click();

  // Revoke created url
  window.URL.revokeObjectURL(internUrl);
};
